import React from "react";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import PersonalDetailsCard from "@widgets/pos/order/customer/personalDetails/PersonalDetailsCard";
import BusinessDetailsCard from "@widgets/pos/order/customer/businessDetails/BusinessDetailsCard";
import DeliveryAddressCard from "@widgets/pos/order/customer/deliveryAddress/DeliveryAddressCard";
import TakeawayAddressCard from "@widgets/pos/order/customer/deliveryAddress/TakeawayAddressCard";
import RequestedTimeCard from "@widgets/pos/order/customer/preferredTime/RequestedTimeCard";
import NoteCard from "@widgets/pos/order/customer/note/NoteCard";
import {useFulfillmentType} from "@widgets/pos/order/hooks/UseFulfillmentType";

/**
 * Last step of the order editor: who orders, where it goes, when, and a note.
 * Payment is always by PIN (at the door or at pickup), so there is no payment
 * card.
 */
const CustomerDetails = (tabProps: OrderEditorTabProps) => {
    const fulfillmentType = useFulfillmentType();

    return (
        <div className={"relative w-full flex flex-col items-center justify-start p-6"}>
            <div className={"w-full max-w-[700px] flex flex-col items-stretch justify-start gap-12"}>
                <PersonalDetailsCard {...tabProps}/>
                <BusinessDetailsCard {...tabProps}/>
                {
                    fulfillmentType === "DELIVERY"
                        ? <DeliveryAddressCard {...tabProps}/>
                        : <TakeawayAddressCard/>
                }
                <RequestedTimeCard {...tabProps}/>
                <NoteCard {...tabProps}/>
            </div>
        </div>
    );
};

export default CustomerDetails;